<script>
import formatAmount from '@/utils/format-currency'
export default {
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },

  computed: {
    pb() {
      return JSON.parse(this.comment.commentText)
    },
  },

  methods: {
    formatAmount,
  },
}
</script>

<template>
  <div>
    <p>Gross Amount: {{ formatAmount(pb.GrossAmount) }}</p>
    <p
      >Regular Hours: {{ formatAmount(pb.RegularHoursUnitRate) }} x
      {{ pb.RegularHours }}</p
    >
    <p v-if="pb.Overtimehours > 0"
      >Overtime: {{ pb.OvertimeHours }} x
      {{ formatAmount(pb.OvertimeHoursUnitRate) }}</p
    >
  </div>
</template>
